// src/app/departments/services/department-upload.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

import { DepartmentImportRow } from '../models/department-import-row.model';

export interface CurrentUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  roles: { id: number; name: string }[];
  jobTitleRoles: any[];
  departmentRoles: any[];
  jobTitle: string | null;
  reportTo: string | null;
}

export interface DepartmentDto {
  name: string;
  code: string;
  parentDepartmentCode?: number | null;
}

export interface Department {
  id: number;
  name: string;
  code: string;
  parentDepartment?: { id: number; name: string; code: string } | null;
}

export interface ApiResponse<T> {
  status: string;
  data: T;
}

@Injectable({ providedIn: 'root' })
export class DepartmentUploadService {
  private readonly baseUrl = environment.apiBaseUrl;

  constructor(private readonly http: HttpClient) {}

  uploadRows(rows: DepartmentImportRow[]): Observable<Department[]> {
    const payload: DepartmentDto[] = rows.map((r) => this.mapRowToApi(r));
    return this.http
      .post<ApiResponse<Department[]>>(`${this.baseUrl}/api/departments/multiple`, payload)
      .pipe(map((res) => res.data));
  }

  getCurrentUser(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>(`${this.baseUrl}/api/account/get-current-user`);
  }

  private mapRowToApi(row: DepartmentImportRow): DepartmentDto {
    const name = (row.Name ?? '').toString().trim();
    const code = (row.Code ?? '').toString().trim();

    const parent = this.parseOptionalNumber(row.ParentDepartmentCode);

    return {
      name,
      code,
      ...(parent !== null ? { parentDepartmentCode: parent } : {}), // not required
    };
  }

  private parseOptionalNumber(value: DepartmentImportRow['ParentDepartmentCode']): number | null {
    if (value === null || value === undefined) return null;
    const s = String(value).trim();
    if (!s.length) return null;
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }
}